import { FC, memo } from 'react';
import SectionWrapper from '@components/SectionWrapper';
import ContentWrapper from '@components/ContentWrapper';
import VideoBlock, {
  Props as VideoBlockProps,
} from '@components/VideoBlock/VideoBlock';
import ContentGrid, {
  Props as ContentGridProps,
} from '@components/ContentGrid/ContentGrid';
import VideoCarousel, {
  Props as VideoCarouselProps,
} from '@components/VideoCarousel/VideoCarousel';

type ContentBlock =
  | (ContentGridProps & { _modelApiKey: 'tabs_grid' })
  | (VideoBlockProps & { _modelApiKey: 'video_block' })
  | (VideoCarouselProps & { _modelApiKey: 'video_carousel' });

type OverviewContentProps = {
  overviewContent?: ContentBlock[];
};

const OverviewContentSection: FC<OverviewContentProps> = ({
  overviewContent = [],
}) => (
  <>
    {overviewContent.map(contentBlock => {
      // eslint-disable-next-line no-underscore-dangle
      switch (contentBlock._modelApiKey) {
        case 'tabs_grid':
          return (
            <ContentGrid
              key={contentBlock.id}
              {...contentBlock}
              noWrapperSpacing
            />
          );

        case 'video_block':
          return (
            <SectionWrapper key={contentBlock.id} noSpacing>
              <ContentWrapper>
                <VideoBlock
                  heading={contentBlock.heading}
                  eyebrow={contentBlock.eyebrow}
                  subheading={contentBlock.subheading}
                  video={contentBlock.video}
                  videoPoster={contentBlock.videoPoster}
                  buttonLabel={contentBlock.buttonLabel}
                  buttonLink={contentBlock.internalButtonLink}
                  darkText={contentBlock.darkText}
                  noWrapperSpacing
                  rounded
                />
              </ContentWrapper>
            </SectionWrapper>
          );

        case 'video_carousel':
          return (
            <VideoCarousel key={contentBlock.id} {...contentBlock} isCompact />
          );

        default:
          return null;
      }
    })}
  </>
);

export default memo(OverviewContentSection);
